import React, { Suspense, useMemo } from 'react';
import Portlet from '../../../app/components/portlet/Portlet';
import PortletBody from '../../../app/components/portlet/PortletBody';
import AnalyticSkeleton from '../../../assets/Skeleton/analyticsSkeleton';
import SupersetEmbed from './SupersetEmbed';
import useAuth from '../../../hooks/useAuth';

const AnalyticsDashboard = () => {
  const { user } = useAuth();
  const session = useMemo(() => ({
    userId: user?.id?.toString() ?? "",
    name: user?.firstName,
    tenantId: user?.company?.id,
  }), [user?.id, user?.firstName, user?.company?.id]);

  return (
    <div>
       <Suspense fallback={<AnalyticSkeleton />}>
        <Portlet>
        <div className="portlet__body-bg p-0">
          <PortletBody className=" bg-transparent rounded p-0">
                  <SupersetEmbed session={session}/>
            </PortletBody>
          </div>
        </Portlet>
      </Suspense>
    </div>
  );
};
export default AnalyticsDashboard;
